import React from 'react';
import VacationSelect from './VacationSelect';
import VacationShow from './VacationShow';

const DaysOffHome = () => {
    return (
        <div>
            <VacationSelect />
            <VacationShow />
        </div>
    );
};

export default DaysOffHome;